var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"base-text-button",class:{ disabled: !_vm.enabled },attrs:{"flat":"","disabled":!_vm.enabled},on:{"click":_vm.emitButtonClicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }